export class OutsourcingFormChoiceOptionModel {
  id?: number; // Django PK
  option_text: string;
  option_value?: string;
  display_order?: number;
  is_default_selected?: boolean;
  created_by?: number;
  modified_by?: number;
  question: number | string;

  constructor(data?: Partial<OutsourcingFormChoiceOptionModel>) {
    Object.assign(this, data);
  }

}

export class OutsourcingFormChoiceOptionResponseModel {
  count!: number;
  next!: string;
  previous!: string;
  results!: OutsourcingFormChoiceOptionModel[];

  constructor(data?: Partial<OutsourcingFormChoiceOptionResponseModel>) {
    Object.assign(this, data);
    if (data?.results) {
      this.results = data.results.map(option => new OutsourcingFormChoiceOptionModel(option));
    } else {
      this.results = [];
    }
  }
}

export class OutsourcingFormQuestionModel {
  id?: string; // Django PK or UUID for unique identification in UI
  question_text: string;
  question_type: 'TEXT_SHORT' | 'TEXT_LONG' | 'NUMBER' | 'CURRENCY' | 'BOOLEAN_YES_NO' | 'DATE' | 'FILE_UPLOAD' | 'MULTIPLE_CHOICE_SINGLE' | 'MULTIPLE_CHOICE_MULTI' | 'DROPDOWN' | 'MULTIPLE_FILES';
  is_required: boolean;
  display_order?: number;
  placeholder_text?: string;
  help_text?: string;
  config_options?: any; // For choices, min/max, etc.
  choice_details?: OutsourcingFormChoiceOptionModel[]; // Specific to choice types
  section: number
  created_by: number


  constructor(data?: Partial<OutsourcingFormQuestionModel>) {
    Object.assign(this, data);
    if (data?.choice_details) {
      this.choice_details = data.choice_details.map(option => new OutsourcingFormChoiceOptionModel(option));
    }
  }
}

export class OutsourcingFormSectionModel {
  id?: number; // Django PK
  section_title: string;
  description?: string;
  display_order?: number;
  questions: OutsourcingFormQuestionModel[];
  outsourcing_form_id?: string; // Added for consistency with backend model
  outsourcing_form_name?: string; // Added for consistency with backend model
  created_by?: number;
  modified_by?: string;
  created_by_name?: string;
  modified_by_name?: string;
  created_at?: Date;
  modified_at?: Date;


  constructor(data?: Partial<OutsourcingFormSectionModel>) {
    Object.assign(this, data);
    if (data?.questions) {
      this.questions = data.questions.map(question => new OutsourcingFormQuestionModel(question));
    } else {
      this.questions = [];
    }
  }
}

export class OutsourcingFormModel {
  id?: number; // Backend DB ID
  outsourcing_form_id?: string; // UUID from Django
  name: string;
  description?: string;
  category: string; // Or a more detailed category object if needed
  status: 'DRAFT' | 'ACTIVE' | 'ARCHIVED';
  sections: OutsourcingFormSectionModel[];
  created_by?: string;
  created_by_name?: string;
  modified_by?: string;
  modified_by_name?: string;
  category_details?: {
    name: string;
    id: number;
  };
  created_at?: Date;
  modified_at?: Date;
  overall_submission_notes:any

  constructor(data?: Partial<OutsourcingFormModel>) {
    Object.assign(this, data);
    if (data?.sections) {
      this.sections = data.sections.map(section => new OutsourcingFormSectionModel(section));
    } else {
      this.sections = [];
    }
  }
}

export class OutsourcingFormQuestionTypeListResponseModel {
  results: {
    code: string; // Changed to string based on how it's used in questionTypes.push
    name: string;
  }[];

  constructor(data?: Partial<OutsourcingFormQuestionTypeListResponseModel>) {
    Object.assign(this, data);
    if (!this.results) {
      this.results = [];
    }
  }
}

export class OutsourcingFormResponseModel {
  count!: number;
  next!: string;
  previous!: string;
  results!: OutsourcingFormModel[];

  constructor(data?: Partial<OutsourcingFormResponseModel>) {
    Object.assign(this, data);
    if (data?.results) {
      this.results = data.results.map(form => new OutsourcingFormModel(form));
    } else {
      this.results = [];
    }
  }
}

// OutsourcingFormSectionResponseModel is already a class in your provided code,
// so no change is needed there, but I'll include it for completeness
export class OutsourcingFormSectionResponseModel {
  count!: number;
  next!: string;
  previous!: string;
  results!: OutsourcingFormSectionModel[];

  constructor(data?: Partial<OutsourcingFormSectionResponseModel>) {
    Object.assign(this, data);
    if (data?.results) {
      this.results = data.results.map(section => new OutsourcingFormSectionModel(section));
    } else {
      this.results = [];
    }
  }
}

export class OutsourcingFormQuestionResponseModel {
  count!: number;
  next!: string;
  previous!: string;
  results!: OutsourcingFormQuestionModel[];

  constructor(data?: Partial<OutsourcingFormQuestionResponseModel>) {
    Object.assign(this, data);
    if (data?.results) {
      this.results = data.results.map(question => new OutsourcingFormQuestionModel(question));
    } else {
      this.results = [];
    }
  }
}

